import { render, staticRenderFns } from "./PricingTable.vue?vue&type=template&id=6100c524&scoped=true&"
import script from "./PricingTable.vue?vue&type=script&lang=js&"
export * from "./PricingTable.vue?vue&type=script&lang=js&"
import style0 from "./PricingTable.vue?vue&type=style&index=0&id=6100c524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6100c524",
  null
  
)

export default component.exports